import { render, staticRenderFns } from "./ChipPaymentValue.vue?vue&type=template&id=11d24380"
import script from "./ChipPaymentValue.vue?vue&type=script&lang=js"
export * from "./ChipPaymentValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports